import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { TripDetailConstant } from "./TripDetailConstant";

const initialState = {
    TripDetailDataList: [],
    TripDetailDataLoading: {
    isLoading: false,
  },



};

export const TripDetailDataReducer = persistReducer(
  {
    storage,
    key: "TripDetailData",
    whitelist: ["TripDetailDataList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case TripDetailConstant.TRIP_DETAIL_REQUEST: {
        return {
          ...state,
          TripDetailDataList: [],
          TripDetailDataLoading: {
            isLoading: true,
          },
        };
      }

      case TripDetailConstant.TRIP_DETAIL_RESPONSE: {
        return {
          ...state,
          TripDetailDataList: payload,
          TripDetailDataLoading: {
            isLoading: false,
          },
        };
      }

     

      default:
        return state;
    }
  }
);
